<div class="container">
  <h1 class="page-title">{{ 'ReceivingRegistration.Button.New' | translate }}</h1>
  <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="preview($event)"  (onClear)="onClear()"
      chooseLabel="{{ 'ReceivingRegistration.Button.Select' | translate }}" uploadLabel="{{ 'ReceivingRegistration.Button.Preview' | translate }}" cancelLabel="{{ 'ReceivingRegistration.Button.Cancel' | translate }}" accept=".xls,.xlsx"   >

    <ng-template pTemplate="toolbar">
      <button #uploadBtn pButton pRipple label="{{ 'ReceivingRegistration.Button.Upload' | translate }}"  class="p-button-success ml-1"  [disabled]="showUploadBtn()" (click)="upload()"></button>

      <button #uploadBtn pButton pRipple label="{{ 'ReceivingRegistration.Button.TemplateDownload' | translate }}"   class="p-button-info ml-1"   (click)="templateDownloadBtn()"></button>
    </ng-template>

    <ng-template pTemplate="content" let-files>
      <div  *ngIf="showTable" >
        <p-table class="datatable" [value]="previewData"  [scrollable]="true"  [autoLayout]="true" [style]="{ 'overflow-y': 'auto' }"  [paginator]="true" [rows]="10"  >
          <ng-template pTemplate="body" let-row >
            <tr>
                <td *ngFor="let obj of row"  [ngStyle]="{'width':'150px'}" >{{obj}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </ng-template>
  </p-fileUpload>
</div>
